// extracted by mini-css-extract-plugin
module.exports = {"tooltipCss":"view_tooltipCss_261I9","tooltip":"view_tooltip_3gKhn"};